"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenSchema = exports.TokenTypeEnum = void 0;
const zod_1 = require("zod");
const Metadata_1 = require("./Metadata");
var TokenTypeEnum;
(function (TokenTypeEnum) {
    TokenTypeEnum["ERC20"] = "ERC20";
    TokenTypeEnum["POOL"] = "POOL";
    TokenTypeEnum["VOTING_ESCROW"] = "VOTING_ESCROW";
})(TokenTypeEnum || (exports.TokenTypeEnum = TokenTypeEnum = {}));
exports.TokenSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'id is required' }),
    name: zod_1.z.string({ required_error: 'name is required' }),
    symbol: zod_1.z.string({ required_error: 'symbol is required' }),
    logo: zod_1.z.string().optional().nullable(),
    decimals: zod_1.z.number({ required_error: 'decimals is required' }),
    type: zod_1.z.nativeEnum(TokenTypeEnum),
    metadata: Metadata_1.TokenMetadataSchema.optional().nullable(),
});
